export default class DynamicResponsiveChecker
{
    constructor(groups) {
        this.groups = groups;

        window.addEventListener('resize', () => this.check());

        this.check();
    }

    check() {
        let num = 1;
        for (let group of this.groups) {
            this.checkGroup(group, num);
            num ++;
        }
    }

    checkGroup(group, num) {
        const className = 'responsive-' + num;

        const leftElement = group.getLeftElement();
        const rightElement = group.getRightElement();
        const minSpace = group.getMinSpace();

        const firstRightPos = leftElement.getBoundingClientRect().right;
        const secondLeftPos = rightElement.getBoundingClientRect().left;

        const diff = secondLeftPos - firstRightPos;

        if (diff < minSpace) {
            group.hide();

            document.body.classList.add(className);
        } else {
            group.show();

            document.body.classList.remove(className);
        }
    }
}
